export { default } from "./getUpdatedNodeTypeCount";
